import { Stack } from '@mui/material';
import { QualificationPromptPlaceholders } from 'features/co-pilot/campaign-builder/campaign-builder.types';
import PaiTextArea from 'features/ui/base-components/pai-text-area';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  promptPlaceholders: QualificationPromptPlaceholders;
  hasOldKeys: boolean;

  handleAiQualifierDetailsChange(type: keyof QualificationPromptPlaceholders): (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const AiContactQualifierDetails: React.FC<Props> = ({ promptPlaceholders, hasOldKeys, handleAiQualifierDetailsChange }) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <PaiTextArea
        label={t('mustHaveCriteria')}
        boldLabel={true}
        placeholder={t('mustHaveCriteriaPlaceholder')}
        value={promptPlaceholders['required']}
        variant={'white'}
        rows={5}
        onChange={handleAiQualifierDetailsChange('required')}
      />
      <PaiTextArea
        label={t('niceToHaveCriteria')}
        boldLabel={true}
        placeholder={t('niceToHaveCriteriaPlaceholder')}
        value={promptPlaceholders['preferred']}
        variant={'white'}
        rows={5}
        onChange={handleAiQualifierDetailsChange('preferred')}
      />
      <PaiTextArea
        label={t('excludeCriteria')}
        boldLabel={true}
        placeholder={t('excludeCriteriaPlaceholder')}
        value={promptPlaceholders['disqualifying']}
        variant={'white'}
        rows={5}
        onChange={handleAiQualifierDetailsChange('disqualifying')}
      />
      {hasOldKeys && (
        <>
          <PaiTextArea
            label={t('aiBriefingAdditionalInfoLabel')}
            boldLabel={true}
            placeholder={t('aiBriefingAdditionalInfoDescription')}
            value={promptPlaceholders['additionalContactInfo'] ?? ''}
            variant={'white'}
            rows={5}
            onChange={handleAiQualifierDetailsChange('additionalContactInfo')}
          />
          <PaiTextArea
            label={t('aiBriefingCompanyCharacteristicsLabel')}
            boldLabel={true}
            placeholder={t('aiBriefingCompanyCharacteristicsDescription')}
            value={promptPlaceholders['companyCharacteristics'] ?? ''}
            variant={'white'}
            rows={5}
            onChange={handleAiQualifierDetailsChange('companyCharacteristics')}
          />
          <PaiTextArea
            label={t('aiBriefingCompanyChallengesLabel')}
            boldLabel={true}
            placeholder={t('aiBriefingCompanyChallengesDescription')}
            value={promptPlaceholders['companyChallenges'] ?? ''}
            variant={'white'}
            rows={5}
            onChange={handleAiQualifierDetailsChange('companyChallenges')}
          />
          <PaiTextArea
            label={t('aiBriefingCultureValuesLabel')}
            boldLabel={true}
            placeholder={t('aiBriefingCultureValuesDescription')}
            value={promptPlaceholders['organizationalWorkingCultureValues'] ?? ''}
            variant={'white'}
            rows={5}
            onChange={handleAiQualifierDetailsChange('organizationalWorkingCultureValues')}
          />
        </>
      )}
    </Stack>
  );
};

export default AiContactQualifierDetails;
